import {
  required,
  requiredUnless,
  minLength,
  maxLength,
  minValue,
  email
} from "vuelidate/lib/validators";
import { parsePhoneNumber } from "awesome-phonenumber";
import axios from "axios";
export default {
  validations: {
    password: {
      required,
      minLength: minLength(8),
      complexity: function(value) {
        return /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])/.test(
          value
        );
      }
    },
    email: {
      required,
      email,
      isUnique(value) {
        if (value === "") return true;
        return new Promise(resolve => {
          axios({
            method: "post",
            url: "/emailunique",
            data: {
              email: value
            }
          }).then(resp => {
            resolve(resp.data.unique);
          });
        });
      },
      isValidOrganization(value) {
        if (this.isProvider) {
          return true;
        }
        if (
          value == null ||
          value === "" ||
          value.indexOf("@") === -1 ||
          value.indexOf(".") === -1
        )
          return true;
        return new Promise(resolve => {
          const token = this.$route.query.token;
          axios({
            method: "post",
            url: "/validorganization",
            data: {
              email: value,
              invitation_code: this.invitation_code,
              // Add token conditionally for SAML orgs without valid domain (personal emails)
              ...(token && { token })
            }
          }).then(resp => {
            this.$emit("organizations-update", resp.data);
            resolve(resp.data.valid);
          });
        });
      }
    },
    city: { required },
    zipcode: {
      required,
      minLength: minLength(4)
    },
    address1: { required },
    address2: {},
    country: { required },
    firstName: {
      required: requiredUnless(function() {
        return this.anonymous == true;
      })
    },
    lastName: {
      required: requiredUnless(function() {
        return this.anonymous == true;
      })
    },
    preferredName: { maxLength: maxLength(255) },
    birthDate: { required },
    photo: { required },
    uniqueIdentifier: {
      required,
      minLength: minLength(4)
    },
    bio: { required, maxLength: maxLength(750) },
    introductionEmail: { maxLength: maxLength(750) },
    about: { maxLength: maxLength(750) },
    contact1Name: { required },
    contact1Telephone: {
      required,
      isPhone(value) {
        if (!value) return false;
        const pn = parsePhoneNumber(value);
        return pn && pn.valid && pn.possibility === "is-possible";
      }
    },
    contact2Name: {},
    contact2Telephone: {
      isPhone(value) {
        if (!value) return false;
        const pn = parsePhoneNumber(value);
        return pn && pn.valid && pn.possibility === "is-possible";
      }
    },
    telephone: {
      required,
      isPhone(value) {
        if (!value) return false;
        const pn = parsePhoneNumber(value);
        return pn && pn.valid && pn.possibility === "is-possible";
      }
    },
    serviceYears: {
      required,
      minValue: minValue(1) // Must set provider years greater than 0
    },
    specialty: {},
    gender: { required },
    designation: { required },
    graduationDate: { required }
  }
};
